<template>
    <div class="page">
        <div class="split-row"></div>
        <div class="content">
            <div class="title">
                <div class="title-left"><span class="title-text">BU维护</span></div>
            </div>
            <div class="search">
                <el-form inline>
                    <el-form-item label="BU名称">
                        <el-input v-model="searchForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="关联部门">
                        <el-cascader  
                        v-model="searchForm.organizationId" 
                        :options="orgTree"
                        filterable
                        :props="{
                            value: 'id',
                            label: 'name',
                            children: 'childs',
                            checkStrictly: true,
                            emitPath: false
                        }"
                        clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="服务区域">
                        <el-cascader  v-model="searchForm.divisionId" :props="{
                            lazy:true,
                            lazyLoad:loadDivision,
                            value: 'id',
                            label: 'name',
                            emitPath: false
                        }"
                        clearable></el-cascader>
                    </el-form-item>
                </el-form>
                <div class="btns">
                    <button class="com-btn round" @click="search">查询</button>
                    <button class="com-btn round" @click="reset">重置</button>
                </div>
            </div>
        </div>
        <div class="split-row"></div>
        <div class="content basicData">
            <div class="mb-10">
                <button class="com-btn round" @click="addOrEdit()">新建</button>
            </div>
            <div class="table_box">
                <el-table :data="tableData" ref="table" class="new-table mb-10">
                    <el-table-column type="index" width="48" label="编号" align="center"></el-table-column>
                    <el-table-column prop="name" label="BU名称"></el-table-column>
                    <el-table-column prop="divisionIds" label="服务区域" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.divisionIds.map(item=>item.divisionName === '市辖区' ? item.provinceName : item.divisionName).join(', ') }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="organizationIds" label="关联部门" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.organizationIds.map(item=>item.name).join(', ') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <button class="com-btn text" @click="addOrEdit(scope.row.id)">编辑</button>
                            <button class="com-btn text red" @click="remove(scope.row)">删除</button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tx-right">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageInfo.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="pageInfo.rows"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageInfo.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {treeDataRemoveEmptyChilds} from '@/utils'
    export default {
        name: 'keep-alive',
        data () {
            return {
                orgTree: [],
                searchForm: {
                    divisionId: '',
                    name: '',
                    organizationId: ''
                },
                tableData: [],
                pageInfo: {
                    page: 1,
                    rows: 10,
                    total: 0
                }
            }
        },
        created () {
            this.getOrgTrees()
            this.getList()
        },
        activated () {
            this.getList()
        },
        methods: {
            getOrgTrees () {
                this.$store.dispatch('a:organization/getOrgTree', {parameters:{}}).then(
                    res => {
                        this.orgTree = treeDataRemoveEmptyChilds(res)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            loadDivision (node, resolve) {
                this.$store.dispatch('a:maintainAreaInfo/divisionList', {parentId: node.root ? 0 : node.value}).then(
                    res => {
                        resolve(res.map(item => ({...item, leaf: node.level >= 1})))
                    },
                    rej => {
                        this.$message.error(rej.errorInfo)
                    }
                )
            },
            getList () {
                this.$store.dispatch('a:bu/getBuList', {parameters: this.searchForm, page: this.pageInfo.page, rows: this.pageInfo.rows}).then(
                    res => {
                        this.tableData = res.list
                        this.pageInfo.total = res.pageInfo.total
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            search () {
                this.pageInfo.page = 1
                this.getList()
            },
            reset () {
                this.searchForm = this.$options.data().searchForm
                this.pageInfo = this.$options.data().pageInfo
                this.getList()
            },
            remove (row) {
                this.$confirm(this.$t('删除后无法恢复，确认删除选择的记录吗'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false
                }).then(()=>{
                    this.$store.dispatch('a:bu/removeBu', {parameters: {id: row.id}}).then(
                        () => {
                            this.$message.success('删除成功！')
                            this.getList()
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {})
            },
            handleSizeChange (pageSize) {
                this.pageInfo.rows = pageSize
                this.pageInfo.page = 1
                this.getList()
            },
            handleCurrentChange (currentPage) {
                this.pageInfo.page = currentPage
                this.getList()
            },
            addOrEdit (id) {
                this.$router.push({
                    path: '/manageBuAddOrEdit',
                    query: { id }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
